import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "cmp--header_icon-arrow"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.29312 17.7071L15.0002 12L9.29312 6.29291L7.87891 7.70712L12.1718 12L7.87891 16.2929L9.29312 17.7071Z",
  fill: "#E80033"
}, null, -1);
const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}